import * as React from "react";
import type { SVGProps } from "react";
const SvgAlertTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 12.97V8.133m0 8.425v.043m6.048 4.03H5.952a3.63 3.63 0 0 1-3.485-2.616c-.187-.645.043-1.316.395-1.888L8.91 5.098c1.416-2.303 4.764-2.303 6.18 0l6.048 11.028c.352.572.582 1.243.395 1.888a3.63 3.63 0 0 1-3.485 2.615"
    />
  </svg>
);
export default SvgAlertTriangle;
